import src from "IMAGE";
export default { src, width: 554, height: 117, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAALklEQVR42g2JyQ0AAAiDXN+PV7TpuPZDCFhEVFVmzozY3aK7m8bdAdhdPQlJxQejvBs3MUt4kAAAAABJRU5ErkJggg=="};
